import React from "react";
import MailIcon from "@mui/icons-material/Mail";
import SmsIcon from "@mui/icons-material/Sms";
import EditIcon from "@mui/icons-material/Edit";
import { Tooltip } from "@mui/material";
import SendEmailDialog from "./SendEmailDialog";
import SendSMSDialog from "./SendSMSDialog";
import { eventEHRCustomToastMessage } from "../../Atoms/custom-toast-message/EventEHRCustomToastMessage";
interface EventEHRContactInformationCardProps {
  contactInfoData: any;
  headingTitle: string;
  handleOnChange?: (value: any) => void;
  isEditable?: boolean;
}

const EventEHRContactInformationCard = ({
  contactInfoData = [
    { label: "Contact Name", value: "Floyd Miles" },
    { label: "Contact Relation", value: "Father" },
    { label: "Contact Email", value: "floyd.miles@gmail.com" },
    { label: "Contact Number", value: "202-555-0119" },
  ],
  headingTitle = "Primary Contact",
  handleOnChange = () => {},
  isEditable,
}: EventEHRContactInformationCardProps) => {
  const [openEmailDialog, setOpenEmailDialog] = React.useState(false);
  const [openSMSDialog, setOpenSMSDialog] = React.useState(false);
  const [selectedContact, setSelectedContact] = React.useState<any>(null);

  const handleOpenEmail = () => {
    if (contactInfoData?.[3]?.value && contactInfoData?.[3]?.value !== "-") {
      setSelectedContact(contactInfoData);
      setOpenEmailDialog(true);
    } else {
      eventEHRCustomToastMessage({
        title: `Please add email to the contact.`,
        status: "error",
      });
    }
  };

  const handleOpenSMS = () => {
    if (contactInfoData?.[2]?.value && contactInfoData?.[2]?.value !== "-") {
      setSelectedContact(contactInfoData);
      setOpenSMSDialog(true);
    } else {
      eventEHRCustomToastMessage({
        title: `Please add phone number to the contact.`,
        status: "error",
      });
    }
  };

  return (
    <div
      className="border-1px-solid-D2D2D2 border-radius-8px"
      style={{ width: "450px" }}
    >
      <div className="pt-3 pb-3 pl-4 pr-4 background-color-F4F4F4 border-radius-8px">
        <div className="font-weight-500 font-size-18px color-393939 ">
          {/* {headingTitle} */}
          <div className="flex justify-between items-center">
            {headingTitle}

            <div className="cursor-pointer flex items-center gap-2 justify-center">
              <Tooltip title="Send Email" placement="top" arrow>
                <MailIcon
                  className="cursor-pointer ml-2"
                  onClick={handleOpenEmail}
                  style={{ color: "#393939" }}
                />
              </Tooltip>
              <Tooltip title="Send SMS" placement="top" arrow>
                <SmsIcon
                  className="cursor-pointer ml-2"
                  onClick={handleOpenSMS}
                  style={{ color: "#393939" }}
                />
              </Tooltip>
              {isEditable && (
                <Tooltip title="Edit" placement="top" arrow>
                  <EditIcon
                    className="cursor-pointer ml-2"
                    onClick={() => {
                      handleOnChange(contactInfoData);
                    }}
                    style={{ color: "#393939" }}
                  />
                </Tooltip>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr",
          width: "fit-content",
        }}
      >
        <div className="p-4 pb-0">
          {contactInfoData?.map((data: any, index: any) => (
            <div
              key={index}
              className="mb-4"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
              }}
            >
              <div className="mr-2 color-727272 font-weight-500 font-size-14px">
                {data?.label}
              </div>
              <div className="color-393939 font-weight-500 font-size-14px common-text-ellipse-style">
                : {data?.value}
              </div>
            </div>
          ))}
        </div>
      </div>
      {openEmailDialog && (
        <SendEmailDialog
          open={openEmailDialog}
          onClose={() => setOpenEmailDialog(false)}
          contact={selectedContact}
        />
      )}
      {openSMSDialog && (
        <SendSMSDialog
          open={openSMSDialog}
          onClose={() => setOpenSMSDialog(false)}
          contact={selectedContact}
        />
      )}
    </div>
  );
};

export default EventEHRContactInformationCard;
